// eslint-disable-next-line no-unused-vars
import React from 'react';
import PropTypes from 'prop-types';

class AccessibleSeatSelector extends React.Component {
  constructor(props) {
    super(props);

    this.createOptions = this.createOptions.bind(this);
  }

  render() {
    return (
      <div className="accessability__select">
        <span className="sr-only" id="option-selected">
          Choose accessibility seats. Currently selected:
        </span>
        <select
          tabIndex="4"
          className="syos-performance-selector__select"
          aria-labelledby="option-selected"
          value={this.props.value}
          onChange={e => {
            e.preventDefault();
            this.props.handler(e.target.value);
          }}
          id="syos-performance-selector"
        >
          <optgroup>
            <option value={0}>None</option>
            {this.createOptions(this.props.max)}
          </optgroup>
        </select>
      </div>
    );
  }

  createOptions(max) {
    let options = [];

    for (let i = 0; i < max; i++) {
      options.push(
        <option value={i + 1} key={i}>
          {i + 1} of {max}
        </option>
      );
    }

    return options;
  }
}

AccessibleSeatSelector.propTypes = {
  value: PropTypes.number,
  max: PropTypes.number,
  handler: PropTypes.func
};

export default AccessibleSeatSelector;



// WEBPACK FOOTER //
// ./src/javascripts/components/AccessibleSeatSelector.js